import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4ca6dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex__column--center" }
const _hoisted_2 = { class: "app__property--medium" }
const _hoisted_3 = { class: "ecran-container" }
const _hoisted_4 = {
  key: 0,
  class: "ecran__details",
  style: {"position":"relative"}
}
const _hoisted_5 = { style: {"display":"flex","justify-content":"flex-start"} }
const _hoisted_6 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"1.2rem"} }, "KG", -1))
const _hoisted_8 = { style: {"font-weight":"bold","font-size":"1rem"} }
const _hoisted_9 = {
  key: 1,
  style: {"display":"flex","align-items":"center","gap":"8px"}
}
const _hoisted_10 = { style: {"font-size":"1rem"} }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { style: {"color":"red"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_14 = {
  key: 3,
  style: {"display":"flex","flex-direction":"column","padding-top":"2rem","padding-bottom":"2rem","padding-right":"2rem"}
}
const _hoisted_15 = { class: "app__label--medium" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "div__btn" }
const _hoisted_19 = {
  key: 1,
  class: "app__label--medium"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ne pare rau, dar a survenit o eroare! Articolul nu poate fi dentificat in baza de date! Redeschideti aplicatia si incercati din nou. Daca eroarea persista va rugam sa contactati Area Sales Manager!", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Multumim!", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$i18n.locale == 'de' ? _ctx.productNameDe : _ctx.$i18n.locale == 'ro' ? _ctx.productNameRo : _ctx.$i18n.locale == 'en' ? _ctx.productNameEn : _ctx.productNameHu), 1),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString() + " ", 1),
        (_ctx.ArticolIdentificatInBazaDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_q_input, {
                  modelValue: _ctx.qUm1,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.qUm1) = $event)),
                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.coreleazaUm1Um2('um1')))
                  ],
                  modelModifiers: { number: true },
                  type: "number",
                  outlined: "",
                  "label-slot": "",
                  min: "0",
                  style: {"max-width":"10rem"},
                  error: _ctx.ErrorRuleIntegerNumberBuc
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.selectedSize.um1), 1)
                  ]),
                  error: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.error6m').replace('xx', _ctx.selectedLength + ' ' + _ctx.selectedSize.um1)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "error"]),
                (_ctx.selectedSize.um2 && _ctx.selectedSize.um2.length>0 && _ctx.selectedSize.um2 != 0)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: _ctx.qUm2,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.qUm2) = $event)),
                        _cache[3] || (_cache[3] = ($event: any) => (_ctx.coreleazaUm1Um2('um2')))
                      ],
                      modelModifiers: { number: true },
                      type: "number",
                      readonly: "",
                      outlined: "",
                      "label-slot": "",
                      min: "0",
                      style: {"max-width":"10rem","margin-left":"1rem"}
                    }, {
                      label: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.selectedSize.cuDebitare)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'card__debitare__options_mobile' : 'card__debitare__options')
                  }, [
                    _createVNode(_component_q_toggle, {
                      modelValue: _ctx.dorescDebitare,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dorescDebitare) = $event)),
                      label: _ctx.$t('message.want_cutting')
                    }, null, 8, ["modelValue", "label"]),
                    (_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 0,
                          maxlength: "1000",
                          type: "textarea",
                          autogrow: "",
                          counter: "",
                          "label-slot": "",
                          outlined: "",
                          modelValue: _ctx.inputFreeTextComments,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                          style: {"min-width":"25rem","margin-left":"8px"}
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('message.cutting_title')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              ((_ctx.selectedSize.um1 || _ctx.selectedSize.um2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.status')) + ": ", 1),
                      _createElementVNode("span", {
                        style: _normalizeStyle('color: ' +_ctx.labelStockColor)
                      }, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.labelStock) + ".", 1)
                      ], 4)
                    ]),
                    (_ctx.loadingStock)
                      ? (_openBlock(), _createBlock(_component_q_circular_progress, {
                          key: 0,
                          indeterminate: "",
                          rounded: "",
                          size: "24px",
                          color: "black"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dorescDebitare)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.remarks_cutting')), 1),
                      _hoisted_13
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!(_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('message.remarks')), 1),
                    _createVNode(_component_q_input, {
                      maxlength: "1000",
                      type: "textarea",
                      autogrow: "",
                      counter: "",
                      class: "input--desire",
                      outlined: "",
                      modelValue: _ctx.inputFreeTextComments,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                      placeholder: _ctx.$t('message.item_details'),
                      dense: "",
                      color: "blue-grey-7"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_16,
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  label: _ctx.$t('message.drop')
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "shopping_cart",
                  "no-caps": "",
                  label: _ctx.$t('message.save'),
                  style: {"margin-left":"5px","background-color":"#9b7d32","color":"white"},
                  onClick: _ctx.editProductInOffer
                }, null, 8, ["label", "onClick"]), [
                  [_directive_close_popup]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
      ])
    ])
  ]))
}